'use es6';

import Context from 'cookie-banner/utils/context';
import { HSPB_LOADED } from 'cookie-banner/constants/hspb';
import BannerRunner from 'cookie-banner/bannerRunner';
import { logError } from 'cookie-banner/utils/hspbUtils';
const loadPrivacyBanner = context => {
  const startRunner = () => {
    const runner = new BannerRunner();
    runner.run();
  };
  const doc = context.getDocument();
  const onDOMReady = () => {
    startRunner();
    doc.removeEventListener('DOMContentLoaded', onDOMReady);
  };
  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', onDOMReady);
  } else {
    startRunner();
  }
};
const startPrivacy = () => {
  try {
    const context = new Context();
    const win = context.getWindow();
    if (win[HSPB_LOADED]) {
      return;
    }
    loadPrivacyBanner(context);
    win[HSPB_LOADED] = true;
  } catch (e) {
    logError(e);
  }
};
startPrivacy();